export function createDefaultTenantAdminUser(overrides = {}) {
  return {
    firstName: "John",
    lastName: "Doe",
    email: "test@accura-tech.com",
    password: "asdf1234",
    admin: true,
    matchingPassword: "asdf1234",
    tenantDTO: {
      id: 0,
    },
    roleDTOs: [
      {
        id: 3,
      },
    ],
    ...overrides,
  };
}
